<div class="pt-5">

  <!-- MAIN COLUMN -->
  <div class="px-3 2xl:px-6">

    <article class="w-full bg-white">

      <!-- FILTERS -->
      <div class="px-4 pt-4 sm:px-6 2xl:px-8">
        <div class="grid grid-cols-12 items-end gap-4 rounded-2xl bg-white/95 p-4 backdrop-blur">

          <!-- CATEGORY SELECT -->
          <div class="col-span-12 lg:col-span-6">
            <label class="mb-2 block text-sm font-semibold text-gray-700">
              Choose Category
            </label>

            <select
              [ngModel]="selectedFeed"
              (ngModelChange)="selectedFeed = $event; getPostingQueueForFeeds($event)"
              class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200">
              <option [ngValue]="null">
                Choose Category
              </option>

              <option *ngFor="let feed of selectOptions.feeds" [ngValue]="feed">
                {{ feed.feed }}
              </option>
            </select>
          </div>

          <!-- CHECK FAILED ARTICLES -->
          <div class="col-span-12 lg:col-span-6">
            <div *ngIf="selectedFeed" class="flex justify-start lg:justify-end">
              <button
                type="button"
                (click)="checkForFailedArticles()"
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200 sm:w-auto">
                Check For Failed Articles
              </button>
            </div>
          </div>

        </div>
      </div>

      <!-- POSTING QUEUE TABLES -->
      <div class="px-4 py-4 sm:px-6 2xl:px-8 2xl:py-6">

        <div *ngIf="selectedFeed && !showFailedArticlesTable">

          <div
            *ngFor="let platformName of getPlatformNames()"
            class="mb-8 w-full last:mb-0">

            <!-- PLATFORM HEADER -->
            <div class="mb-4 grid grid-cols-12 items-center gap-3">

              <div class="col-span-12 lg:col-span-7">
                <h4 class="text-lg font-bold tracking-tight text-gray-900">
                  Posting Queue for {{ selectedFeed.feed }}
                </h4>
              </div>

              <div class="col-span-12 lg:col-span-5">
                <div class="flex items-center justify-start lg:justify-end">
                  <span class="inline-flex items-center gap-2 rounded-full border border-gray-300 bg-gray-50 px-3 py-1.5 text-sm font-semibold text-gray-700">
                    <mat-icon
                      class="!h-5 !w-5 !text-[20px]"
                      [class.text-blue-600]="platformName.toLowerCase() === 'facebook'"
                      [class.text-pink-500]="platformName.toLowerCase() === 'instagram'"
                      [class.text-gray-600]="!['facebook', 'instagram'].includes(platformName.toLowerCase())">
                      {{ getPlatformIcon(platformName) }}
                    </mat-icon>

                    Posts For {{ platformName }}
                  </span>
                </div>
              </div>

            </div>

            <!-- PLATFORM TABLE -->
            <div *ngIf="platformArticles[platformName] && platformArticles[platformName].length > 0; else noArticlesForPlatform">
              <div class="overflow-hidden rounded-2xl bg-white">
                <div class="w-full overflow-x-auto">

                  <table class="w-full min-w-[900px] table-auto text-left text-sm text-gray-500">

                    <thead class="bg-gray-50 text-xs uppercase text-gray-700">
                      <tr>
                        <th scope="col" class="px-6 py-3 text-center">
                          ID
                        </th>

                        <th scope="col" class="px-6 py-3 text-center">
                          Description
                        </th>

                        <th scope="col" class="px-6 py-3 text-center">
                          Scheduled For
                        </th>

                        <th scope="col" class="px-6 py-3 text-center">
                          Post Type
                        </th>

                        <th scope="col" class="px-6 py-3 text-center">
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody
                      cdkDropList
                      [cdkDropListData]="platformArticles[platformName] || []"
                      (cdkDropListDropped)="drop($event, platformName)">

                      <tr
                        *ngFor="let article of platformArticles[platformName] || []"
                        cdkDrag
                        class="cursor-move border-b bg-white transition-colors hover:bg-gray-50">

                        <td class="px-6 py-4 text-center font-medium text-gray-900">
                          {{ article.posting_queue_id }}
                        </td>

                        <td
                          class="max-w-xs cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-6 py-4 text-center text-gray-900 hover:text-blue-700 hover:underline"
                          (click)="editArticle(article)">
                          {{ article.rss_description }}
                        </td>

                        <td class="whitespace-nowrap px-6 py-4 text-center text-gray-900">
                          {{ getDateLabel(article.scheduled_for) }}
                        </td>

                        <td class="max-w-[150px] break-words px-6 py-4 text-center text-gray-900">
                          {{ getTagName(article.tag) }}
                        </td>

                        <td class="px-6 py-4 text-center text-gray-900">
                          <div class="flex justify-center gap-2">

                            <button
                              mat-icon-button
                              class="!bg-red-500 !text-white"
                              (click)="deleteArticle(article)">
                              <mat-icon>delete</mat-icon>
                            </button>

                            <button
                              mat-icon-button
                              class="!bg-green-500 !text-white"
                              (click)="postArticleManually(article)">
                              <mat-icon>send</mat-icon>
                            </button>

                          </div>
                        </td>

                      </tr>
                    </tbody>

                  </table>

                </div>
              </div>
            </div>

            <ng-template #noArticlesForPlatform>
              <div class="mt-4 w-full rounded-2xl border border-dashed border-gray-300 bg-gray-50 p-5 text-center text-sm text-gray-500">
                No articles found for {{ platformName }} in this queue.
              </div>
            </ng-template>

          </div>

          <div
            *ngIf="hasNoArticles()"
            class="w-full rounded-2xl border border-dashed border-gray-300 bg-gray-50 p-5 text-center text-sm text-gray-500">
            No articles found for publication on any platform for this Category.
          </div>

        </div>

        <!-- FAILED ARTICLES TABLE -->
        <div *ngIf="showFailedArticlesTable">

          <!-- FAILED ARTICLES HEADER -->
          <div class="mb-6 grid grid-cols-12 items-center gap-4">

            <div class="col-span-12 lg:col-span-8">
              <h4 class="text-lg font-bold tracking-tight text-gray-900">
                Failed Articles for {{ selectedFeed?.feed }}
              </h4>

              <p class="mt-1 text-sm text-gray-500">
                Review failed articles, update publication platform and retry editing where needed.
              </p>
            </div>

            <div class="col-span-12 flex justify-start lg:col-span-4 lg:justify-end">
              <button
                mat-stroked-button
                color="primary"
                (click)="goBackToPostingQueue()">
                ← Back To Posting Queue
              </button>
            </div>

          </div>

          <div *ngIf="failedArticles.length > 0; else noFailedArticles">
            <div class="overflow-hidden rounded-2xl bg-white">
              <div class="w-full overflow-x-auto">

                <table class="w-full min-w-[1300px] table-auto text-left text-sm text-gray-500">

                  <thead class="bg-gray-50 text-xs uppercase text-gray-700">
                    <tr>
                      <th scope="col" class="px-6 py-3 text-center">
                        ID
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Description
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Platform
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Post Type
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Error Message
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Status
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Publication Platform
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Published Article
                      </th>

                      <th scope="col" class="px-6 py-3 text-center">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="let article of failedArticles"
                      class="border-b bg-white transition-colors hover:bg-gray-50">

                      <td class="px-6 py-4 text-center font-medium text-gray-900">
                        {{ article.posting_queue_id }}
                      </td>

                      <td class="max-w-xs overflow-hidden text-ellipsis whitespace-nowrap px-6 py-4 text-center text-gray-900">
                        {{ article.rss_description }}
                      </td>

                      <td class="px-6 py-4 text-center text-gray-900">
                        <ng-container *ngIf="'' + article.tag !== 'postnow' else emptyPlatform">
                          {{ article.social_platform_name }}
                        </ng-container>

                        <ng-template #emptyPlatform>
                          —
                        </ng-template>
                      </td>

                      <td class="whitespace-nowrap px-6 py-4 text-center text-gray-900">
                        {{ getTagName(article.tag) }}
                      </td>

                      <td class="group relative max-w-xs truncate whitespace-nowrap px-6 py-4 text-center text-gray-900">
                        <span>
                          {{ article.error_response_message || 'N/A' }}
                        </span>

                        <div class="invisible absolute bottom-full left-1/2 z-10 mb-1 w-max max-w-sm -translate-x-1/2 rounded-lg bg-gray-800 px-3 py-2 text-xs text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:visible group-hover:opacity-100">
                          {{ article.error_response_message || 'N/A' }}
                        </div>
                      </td>

                      <td class="px-6 py-4 text-center text-gray-900">
                        {{ article.post_status === 'Permanently Failed' ? 'Permanently Failed (system tried 3 times to publish)' : article.post_status }}
                      </td>

                      <td class="whitespace-nowrap px-4 py-2 text-center text-gray-900">
                        <mat-form-field appearance="fill" class="w-40 min-w-[150px] rounded-md bg-white">
                          <mat-label class="text-sm text-gray-600">
                            Platform
                          </mat-label>

                          <mat-select [(ngModel)]="selectedPlatformsMap[article.posting_queue_id]" disableRipple>
                            <mat-option value="Facebook">
                              Facebook
                            </mat-option>

                            <mat-option value="Instagram">
                              Instagram
                            </mat-option>

                            <!-- <mat-option value="TikTok">TikTok</mat-option> -->
                          </mat-select>
                        </mat-form-field>
                      </td>

                      <td class="px-6 py-4 text-center text-gray-900">
                        <mat-checkbox
                          [(ngModel)]="article.checked"
                          (change)="onCheckboxChange(article, $event.checked)"
                          [disabled]="!selectedPlatformsMap[article.posting_queue_id]">
                        </mat-checkbox>
                      </td>

                      <td class="px-6 py-4 text-center text-gray-900">
                        <button
                          mat-icon-button
                          class="!bg-blue-500 !text-white"
                          (click)="editArticle(article)">
                          <mat-icon>edit</mat-icon>
                        </button>
                      </td>

                    </tr>
                  </tbody>

                </table>

              </div>
            </div>
          </div>

          <ng-template #noFailedArticles>
            <div class="w-full rounded-2xl border border-dashed border-gray-300 bg-gray-50 p-5 text-center text-sm text-gray-500">
              No failed articles were found for this Category.
            </div>
          </ng-template>

        </div>

      </div>

    </article>

  </div>

</div>